module.exports = __webpack_public_path__ + "img/Capteur_GPS_BeeTrack.3426ca4e.png";